<div
  (click)="itemClickHandler(dataItem())"
  class="flex-container"
>
  <div class="flex-item">
    <div
      [ngStyle]="{ background: addAlpha(dataItem()?.color) }"
      class="security-icon-container"
    >
      <span [ngStyle]="{ color: dataItem()?.color }">{{ getCurrentSymbol(dataItem().ticker) }}</span>
    </div>
  </div>
  <div class="flex-item">
    <div class="security-item-info">
      @if (dataItem()?.assetType !== 'option') {
        <div
          class="first-name"
          innerHTML="{{ dataItem().description | highlight: searchText() }}"
        ></div>
      }
      <div
        class="second-name"
        innerHTML="{{ dataItem().ticker | highlight: searchText() }}"
      ></div>
    </div>
  </div>
  <div class="flex-item">
    <div class="security-item-assettype">{{ dataItem()?.assetType }}</div>
  </div>
  <div class="flex-item">
    <div class="security-item-cusip">
      @if (dataItem()?.assetType === 'equity') {
        <span>
          @if (dataItem()?.sedol) {
            {{ dataItem()?.sedol }}
          } @else {
            {{ dataItem()?.cusip }}
          }
        </span>
      } @else {
        <span>{{ dataItem()?.cusip }}</span>
      }
    </div>
  </div>
  <div class="flex-item tw:flex-col">
    @if (dataItem()?.longPosition !== 0) {
      <div class="security-item-amount-container">
        <i class="custom-icon-top-chart"></i>
        <span class="amount">{{ dataItem()?.longPosition | number: '1.0' }} </span>
      </div>
    }
    @if (dataItem()?.shortPosition !== 0) {
      <div class="security-item-amount-container">
        <i class="custom-icon-low-chart"></i>
        <span class="amount">{{ dataItem()?.shortPosition | number: '1.0' }} </span>
      </div>
    }
  </div>
</div>
